import type { Glue, Linked } from '@/types/api'

export interface define {
  _key?: string
  name: string
  zabbix?: string
  monitor: boolean
  glue?: Partial<Glue>
  certificate: string
  linked?: Linked
}

export const factory = (): define & { glue: Glue } => {
  return {
    name: '',
    monitor: false,
    certificate: '',
    zabbix: '',
    glue: {
      id: null,
      url: '',
    },
  }
}
